// extracted by mini-css-extract-plugin
export default {"VariantInput":"styles_VariantInput__OPyYe","VariantInputField":"styles_VariantInputField__u3cEP","VariantDropdown":"styles_VariantDropdown__cIMED"};